import { z } from 'zod';
export const dashboardQuerySchema = z.object({
    workspaceId: z.string().uuid().optional(),
    /** Rolling window used for trend deltas. */
    days: z.coerce.number().int().min(7).max(365).default(30),
});
//# sourceMappingURL=dashboard.contract.js.map